import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { classNames, responsiveVariables } from "../../utils/helpers";
import s from './Icon.module.css';
export const Icon = ({ svg: Component, className, color = 'on-secondary', size = 6, autoWidth, ariaHidden, title, attributes, }) => {
    var _a;
    const rootClassName = classNames(s.root, className, s['--size'], autoWidth && s['--auto']);
    const sizeVariables = responsiveVariables('--st-icon-size', size);
    const icon = React.isValidElement(Component) ? Component : _jsx(Component, {});
    const passedStyles = (attributes === null || attributes === void 0 ? void 0 : attributes.style) || {};
    const style = Object.assign(Object.assign(Object.assign({}, passedStyles), sizeVariables), { '--st-icon-color': `var(--st-color-${color})` });
    return (
    // All icons are decorative, a11y attributes should be set for buttons wrapping them
    _jsx("span", Object.assign({ "data-testid": "st-icon" }, attributes, { "aria-hidden": (_a = ariaHidden !== null && ariaHidden !== void 0 ? ariaHidden : attributes === null || attributes === void 0 ? void 0 : attributes['aria-hidden']) !== null && _a !== void 0 ? _a : true, className: rootClassName, style: style, children: React.cloneElement(icon, {
            focusable: false,
            title,
            'aria-label': title,
        }) })));
};
